import {getApiMetadata} from '../../helpers/api-metadata'
import {fetchJSONWith} from '../../platform/functional-fetch-wrapper'
import type {GenerateRecapRequest, GenerateRecapResponse} from './types'

export async function apiGenerateRecap(params: GenerateRecapRequest): Promise<GenerateRecapResponse> {
  const apiData = getApiMetadata('scribe-recaps-api-data')
  const url = new URL(apiData.url, window.location.origin)

  const {data} = await fetchJSONWith<GenerateRecapResponse>(url.toString(), {
    method: 'POST',
    body: {
      project_number: params.projectNumber,
      owner_type: params.ownerType,
      owner_id: params.ownerIdentifier,
    },
  })

  return data
}
